module.exports = __webpack_public_path__ + "img/pv_month_gen.09fa183d.svg";